import {TFunction} from "i18next";
import {Utils} from "./Utils";

/**
 * The length of the body as the back-end counts it. The browser sends a line break as CR LF, while the value of a
 * textarea has only LF, and the back-end counts UTF-16 code units, as the length of a string does.
 */
function getSentBodyLength(body : string) : number {
    return body.replace(/\r?\n/g, "\r\n").length;
}

/**
 * The error message if adding the files would make more attachments than the maximum number, or make them larger
 * than the maximum size, undefined if not. A maximum which is not known (yet), or which there is not (null, as the
 * back-end sends it), is not checked.
 */
function getAttachmentsError(attachments : File[], newFiles : File[], maxSize : number | null | undefined,
                             maxCount : number | null | undefined,
                             t : TFunction<string, undefined>) : string | undefined
{
    const files = [...attachments, ...newFiles];

    // the back-end refuses a request with more parts than its maximum, after the upload
    if (maxCount != null && files.length > maxCount) {
        return t('portal.messages.mail.attachment-max-count-exceeded', {maxCount: maxCount});
    }

    if (maxSize != null && files.reduce((sum, file) => sum + file.size, 0) > maxSize) {
        return t('portal.messages.mail.attachment-max-size-exceeded', {maxSize: Utils.formatBytes(maxSize)});
    }

    return undefined;
}

/**
 * The error message if the body, as it is sent, is larger than the maximum size, undefined if not (or if the maximum
 * size is not known yet)
 *
 * @param errorKey the translation key of the message, the one the back-end would answer with
 */
function getBodySizeError(body : string, maxSize : number | null | undefined, errorKey : string,
                          t : TFunction<string, undefined>) : string | undefined
{
    return maxSize != null && getSentBodyLength(body) > maxSize ? t(errorKey) : undefined;
}

/**
 * The size checks of a reply or a new mail, done before the upload so the user does not wait for an upload which
 * the back-end then refuses
 */
export const ReplySizeUtils = () => {
    return
}

ReplySizeUtils.getAttachmentsError = getAttachmentsError;
ReplySizeUtils.getBodySizeError = getBodySizeError;
